import { Badge } from '@/app/components/ui/badge';
import type {
  PurchaseRequisitionPriority,
  PurchaseRequisitionStatus,
} from '@/lib/types';

export const statusColors: Record<PurchaseRequisitionStatus, string> = {
  draft: 'bg-gray-100 text-gray-800',
  submitted: 'bg-amber-100 text-amber-800',
  approved: 'bg-blue-100 text-blue-800',
  converted: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
};

export const statusLabels: Record<PurchaseRequisitionStatus, string> = {
  draft: 'Draft',
  submitted: 'Pending Approval',
  approved: 'Approved',
  converted: 'Converted to PO',
  rejected: 'Rejected',
};

export const priorityColors: Record<PurchaseRequisitionPriority, string> = {
  low: 'bg-gray-100 text-gray-700',
  normal: 'bg-blue-50 text-blue-700',
  high: 'bg-orange-100 text-orange-800',
  urgent: 'bg-red-100 text-red-800',
};

export const priorityLabels: Record<PurchaseRequisitionPriority, string> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  urgent: 'Urgent',
};

export function RequisitionStatusBadge({ status }: { status: PurchaseRequisitionStatus }) {
  return <Badge className={statusColors[status]}>{statusLabels[status]}</Badge>;
}

export function RequisitionPriorityBadge({ priority }: { priority: PurchaseRequisitionPriority }) {
  return <Badge className={priorityColors[priority]}>{priorityLabels[priority]}</Badge>;
}

/** Sum of quantity × estimated unit cost across lines (blank costs count as 0). */
export function estimatedTotal(
  lines: { quantity: string | number; estimated_unit_cost?: string | number | null }[]
): number {
  return lines.reduce(
    (sum, l) => sum + Number(l.quantity || 0) * Number(l.estimated_unit_cost || 0),
    0
  );
}
